import React, { useState, useRef, useEffect } from 'react';
import '../navbar/Navbar.css';
import DropdownMenu from '../navbar/DropdownMenu';
import { FaRegUser, FaChevronDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { navMenus } from '../../data/navMenus';

const LandingNavbar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileAccordions, setMobileAccordions] = useState({});

  // refs separados
  const marketRef = useRef(null);
  const realestateRef = useRef(null);
  const economicRef = useRef(null);
  const topsuburbsRef = useRef(null);
  const userMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const navigate = useNavigate();

  // Cerrar menús al hacer click fuera (desktop y mobile)
  useEffect(() => {
    const handleClickOutside = (e) => {
      // cerrar desktop dropdown si click fuera del dropdown correspondiente
      if (activeMenu) {
        const refMap = {
          market: marketRef,
          realestate: realestateRef,
          economic: economicRef,
          topsuburbs: topsuburbsRef,
        };
        const currentRef = refMap[activeMenu];
        if (currentRef && currentRef.current && !currentRef.current.contains(e.target)) {
          setActiveMenu(null);
        }
      }

      // cerrar user menu si click fuera
      if (userMenuOpen && userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }

      // cerrar mobile menu si click fuera
      if (mobileOpen && mobileMenuRef.current && !mobileMenuRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeMenu, userMenuOpen, mobileOpen]);

  // Redirige a /signup en todos los subitems de los menús
  const handleMenuItemClick = () => {
    navigate('/signup');
    setActiveMenu(null);
    setMobileOpen(false);
  };

  const toggleMobileAccordion = (key) => {
    setMobileAccordions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo-wrapper">
        <Link to="/">
          <img src={logo} alt="INVESCASA" className="navbar__logo-img" />
        </Link>
        <div className="navbar__divider" />
      </div>

      {/* Hamburger (visible en mobile) */}
      <button
        className={`navbar__menu-btn ${mobileOpen ? 'is-open' : ''}`}
        onClick={() => setMobileOpen((v) => !v)}
        aria-label={mobileOpen ? 'Cerrar menú' : 'Abrir menú'}
        aria-expanded={mobileOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Links (desktop) */}
      <ul className="navbar__links">
        <li className="navbar__link-item" onClick={() => setActiveMenu('market')}>
          <span className={activeMenu === 'market' ? 'active' : ''}>Market Cycles</span>
          {activeMenu === 'market' && (
            <div ref={marketRef} className="navbar__dropdown-wrapper">
              <DropdownMenu
                items={navMenus.market.map(item => ({ ...item, onClick: handleMenuItemClick }))}
              />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => setActiveMenu('realestate')}>
          <span className={activeMenu === 'realestate' ? 'active' : ''}>Real Estate Indicators</span>
          {activeMenu === 'realestate' && (
            <div ref={realestateRef} className="navbar__dropdown-wrapper">
              <DropdownMenu
                items={navMenus.realestate.map(item => ({ ...item, onClick: handleMenuItemClick }))}
              />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => setActiveMenu('economic')}>
          <span className={activeMenu === 'economic' ? 'active' : ''}>Economic Indicators</span>
          {activeMenu === 'economic' && (
            <div ref={economicRef} className="navbar__dropdown-wrapper">
              <DropdownMenu
                items={navMenus.economic.map(item => ({ ...item, onClick: handleMenuItemClick }))}
              />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => setActiveMenu('topsuburbs')}>
          <span className={activeMenu === 'topsuburbs' ? 'active' : ''}>Top Suburbs</span>
          {activeMenu === 'topsuburbs' && (
            <div ref={topsuburbsRef} className="navbar__dropdown-wrapper">
              <DropdownMenu
                items={navMenus.topsuburbs.map(item => ({ ...item, onClick: handleMenuItemClick }))}
              />
            </div>
          )}
        </li>
      </ul>

      <div className="navbar__icons" style={{ gap: '1rem' }}>
        <div
          className="navbar__profile-wrapper"
          ref={userMenuRef}
          onClick={() => setUserMenuOpen((open) => !open)}
        >
          <FaRegUser className="navbar__icon" />
          <FaChevronDown className="navbar__arrow navbar__arrow--white" />
          {userMenuOpen && (
            <div className="navbar__dropdown-wrapper navbar__dropdown-wrapper--login">
              <button
                className="navbar__dropdown-item navbar__dropdown-item--login"
                onClick={() => navigate('/login')}
              >
                <FaRegUser className="navbar__dropdown-icon" />
                Log in
              </button>
            </div>
          )}
        </div>
        <button
          className="navbar__login-btn"
          onClick={() => navigate('/signup')}
        >
          Get started
        </button>
      </div>

      {/* Mobile menu overlay */}
      <div
        ref={mobileMenuRef}
        className={`mobile-menu ${mobileOpen ? 'mobile-menu--open' : ''}`}
        role="dialog"
        aria-hidden={!mobileOpen}
      >
        <div className="mobile-menu__content">
          <div className="mobile-menu__header">
            <Link to="/" onClick={() => setMobileOpen(false)}>
              <img src={logo} alt="INVESCASA" className="navbar__logo-img" />
            </Link>
            <button className="mobile-close" onClick={() => setMobileOpen(false)} aria-label="Cerrar">✕</button>
          </div>

          <nav className="mobile-nav">
            <div className="mobile-section">
              <button className="mobile-section__title" onClick={() => toggleMobileAccordion('market')}>
                Market Cycles
                <span className={`mobile-chevron ${mobileAccordions['market'] ? 'open' : ''}`}>▾</span>
              </button>
              <div className={`mobile-section__body ${mobileAccordions['market'] ? 'open' : ''}`}>
                {navMenus.market.map((it, i) => (
                  <button key={i} className="mobile-link" onClick={handleMenuItemClick}>{it.label ?? it}</button>
                ))}
              </div>
            </div>

            <div className="mobile-section">
              <button className="mobile-section__title" onClick={() => toggleMobileAccordion('realestate')}>
                Real Estate Indicators
                <span className={`mobile-chevron ${mobileAccordions['realestate'] ? 'open' : ''}`}>▾</span>
              </button>
              <div className={`mobile-section__body ${mobileAccordions['realestate'] ? 'open' : ''}`}>
                {navMenus.realestate.map((it, i) => (
                  <button key={i} className="mobile-link" onClick={handleMenuItemClick}>{it.label ?? it}</button>
                ))}
              </div>
            </div>

            <div className="mobile-section">
              <button className="mobile-section__title" onClick={() => toggleMobileAccordion('economic')}>
                Economic Indicators
                <span className={`mobile-chevron ${mobileAccordions['economic'] ? 'open' : ''}`}>▾</span>
              </button>
              <div className={`mobile-section__body ${mobileAccordions['economic'] ? 'open' : ''}`}>
                {navMenus.economic.map((it, i) => (
                  <button key={i} className="mobile-link" onClick={handleMenuItemClick}>{it.label ?? it}</button>
                ))}
              </div>
            </div>

            <div className="mobile-section">
              <button className="mobile-section__title" onClick={() => toggleMobileAccordion('topsuburbs')}>
                Top Suburbs
                <span className={`mobile-chevron ${mobileAccordions['topsuburbs'] ? 'open' : ''}`}>▾</span>
              </button>
              <div className={`mobile-section__body ${mobileAccordions['topsuburbs'] ? 'open' : ''}`}>
                {navMenus.topsuburbs.map((it, i) => (
                  <button key={i} className="mobile-link" onClick={handleMenuItemClick}>{it.label ?? it}</button>
                ))}
              </div>
            </div>

            <div className="mobile-section mobile-profile">
              <button className="mobile-login" onClick={() => { setMobileOpen(false); navigate('/login'); }}>Log in</button>
              <button className="mobile-logout" onClick={() => { setMobileOpen(false); navigate('/signup'); }}>Get started</button>
            </div>
          </nav>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
